import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import NotificationBell from './NotificationBell';
import TrialWarningBanner from './TrialWarningBanner';
import CustomerSupportChat from '../Support/CustomerSupportChat';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';
import { Headset } from 'lucide-react';

const MainLayout = () => {
  const { user } = useAuth();
  const [showSupportChat, setShowSupportChat] = useState(false);
  
  // Show support button for institution super_admin and admin only
  const canAccessSupport = user?.institution_id && ['super_admin', 'admin'].includes(user?.role);

  return (
    <div className="app-container">
      <TrialWarningBanner />
      <Sidebar />
      <main className="main-content">
        {/* Floating Notification Bell - Bottom Right */}
        <div className="fixed bottom-8 right-8 z-50 flex flex-col gap-3">
          <NotificationBell />
          
          {/* Customer Support Button - Only for Institution Admins */}
          {canAccessSupport && (
            <Button
              onClick={() => setShowSupportChat(true)}
              className="h-14 w-14 rounded-full bg-blue-600 hover:bg-blue-700 shadow-lg flex items-center justify-center"
              title="Customer Support"
            >
              <Headset className="w-6 h-6 text-white" />
            </Button>
          )}
        </div>
        
        {/* Customer Support Chat Modal */}
        {canAccessSupport && (
          <CustomerSupportChat 
            open={showSupportChat} 
            onClose={() => setShowSupportChat(false)} 
          />
        )}
        
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;
